<!-- eslint-disable tailwindcss/no-custom-classname -->
<!-- eslint-disable vue/no-v-html -->
<!-- Create a responsive video container: https://stackoverflow.com/a/50014014 -->
<template>
	<div class="containerStyle" data-motion-region data-motion-autoplay="true">
		<iframe
			v-if="player.url"
			data-motion-pause-control
			:title="blok.player_alt"
			:src="player.url"
			frameborder="0"
			:allow="
				preferredMotion === 'reduce' ? 'fullscreen' : 'autoplay; fullscreen'
			"
			webkitallowfullscreen
			mozallowfullscreen
			allowfullscreen
		>
		</iframe>

		<p v-else>
			{{ player.error }}
		</p>
	</div>
</template>

<script setup lang="ts">
import {usePreferredReducedMotion} from "@vueuse/core";
import type {BlokComponent} from "@pkg/shared/types";
import getVideoId from "get-video-id";

const properties = defineProps<{
	blok: Extract<BlokComponent, {component: "sb-video"}>;
}>();

const videoUrl = computed(() => properties.blok.video?.vimeo_raw);
const preferredMotion = usePreferredReducedMotion();

type PlayerValue = {error: null; url: string} | {error: string; url: null};

const player = computed<PlayerValue>(() => {
	const {service, id} = getVideoId(videoUrl.value || "");

	if (service === "vimeo" && id) {
		const autoplay = preferredMotion.value === "reduce" ? 0 : 1;
		const url = `https://player.vimeo.com/video/${id}?autoplay=${autoplay}&loop=0&autopause=0&muted=1&controls=1`;
		return {url, error: null};
	}
	return {url: null, error: `Invalid video URL: ${videoUrl.value}`};
});
</script>

<style scoped>
.containerStyle {
	position: relative;
	outline: none;
	overflow: hidden;
	padding-bottom: 56.25%; /* 16:9 = 9 / 16 = 56.25% */
	height: 0;
	max-width: 100%;
	width: 100%;
}

.containerStyle :deep(iframe) {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
</style>
